import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import ScoreIndicator from "../../../../Component/ScoreIndicator";
import styles from "./styles";

const CountryRiskScores = (props) => {
  const { classes, entity } = props;
  const { t } = useTranslation();

  const { countryRiskScores = {} } = entity;

  return (
    <Grid container direction="row" spacing={2} className={classes.container}>
      {Object.keys(countryRiskScores).map((section) => {
        return (
          <Grid item md={3} container spacing={1} key={section}>
            <ScoreIndicator
              label={t(`labels.country.countryRiskData.sections.${section}`)}
              score={countryRiskScores[section]}
            />
          </Grid>
        );
      })}
    </Grid>
  );
};

export default withStyles(styles, { withTheme: true })(CountryRiskScores);
